<template>
  <form @submit.prevent="submit" class="container mt-lg-5 mb-5 d-flex flex-column gap-3 w-100">
    <!-- Campos del Formulario -->
     
    <div class="d-flex flex-row align-items-center justify-content-start gap-2">
      <router-link :to="'/formularios/ver?idForm='+form.IdFormulario" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="tooltip-text">{{ $t('volver') }}</span>
      </router-link>
      <h2 for="nombreFormulario" class="m-0">{{ form.NombreFormulario }}</h2>
    </div>
    <p class="w-100" style="white-space: pre-wrap;  word-wrap: break-word;">{{ form.Descripcion }}</p>
    
    <div v-if="form.Observacions.some(p => p.Obligatorio)" class="d-flex flex-row gap-1">
      <div class="ps-1 border border-warning fondo-terciario rounded text-danger" style="width: 19px; height: 19px;">*</div>
      <p class="text-wrap text-body-tertiary fs-7 w-100 m-0">{{ $t('obsObligatoria') }}</p>
    </div>

    <div class="d-flex flex-column gap-3 w-100">
      <!-- Divider -->
      <div class="col-12 my-2" style="border-top: 1px solid #ddd; height: 1px"></div>

      <div class="d-flex flex-column gap-2">
        
        <h4 for="nombreFormulario" class="m-0">{{$t('asignarSiguienteEstado')}}:</h4>

        <div class="d-flex gap-2">
          <button v-for="estado of estados" type="button" :key="estado.IdAutorizacionEstado" @click="submit(estado.IdAutorizacionEstado)" class="btn sombra-sm texto-principal" :class="{ 'select-aprobado': estado.Autorizado == true, 'select-desaprobado': estado.Autorizado == false, 'select-nada': estado.Autorizado == null  }">{{ $t(estado.EstadoNombre) }}</button>
          <div v-if="loadingSubmit" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
        <div class="position-relative" style="width: 100%;">
          <label for="descripcion">{{ $t('comentario') }}</label>
          <textarea id="descripcion" v-model="comentario" class="form-control sombra-sm" style="height: 120px; resize: none;" maxlength="500"></textarea>

          <div class="mt-2 text-end">
            <span>{{ comentario.length || 0 }}/500 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
          </div>
        </div>
        <h4 v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="m-0">{{$t('historialDeEstadosDeAutorizacion')}}:</h4>
        <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex flex-column gap-2">
          <div v-for="(nivel, indexNivel) in form.AutorizadoresNivel" :key="nivel.IdAutorizadoresNivel" class="d-flex flex-wrap gap-2 align-items-center">
            <p class="m-0">Nivel {{ indexNivel + 1 }}:</p>
            <div v-for="(autorizacion, index) in autorizaciones.filter(a => a.Autorizadores?.IdAutorizadoresNivel === nivel.IdAutorizadoresNivel)"
              :key="autorizacion.IdAutorizacion" class="d-flex gap-2 align-items-center justify-content-center">
              <div class="tooltip-container">
                <div class="rounded-3 d-inline-flex flex-column align-items-center justify-content-center p-1 px-2 sombra-sm"
                  :class="{ 'select-aprobado-2': autorizacion.AutorizacionEstado.Autorizado === true,
                            'select-desaprobado-2': autorizacion.AutorizacionEstado.Autorizado === false,
                            'select-nada-2': autorizacion.AutorizacionEstado.Autorizado === null}" style="height: 65px;"
                >
                  <span>{{ $t(autorizacion.AutorizacionEstado.EstadoNombre) }}</span>
                  <span class="fs-8 fw-normal">{{ autorizacion.Autorizadores.Persona.Apellido + ' ' + autorizacion.Autorizadores.Persona.Nombre }}</span>
                  <span class="fs-8 fw-normal text-body-secondary">{{ new Date(new Date(autorizacion.FechaHora).setHours(new Date(autorizacion.FechaHora).getHours() - 3)).toLocaleString('es-AR', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      hourCycle: 'h23'
                    }) }}</span>
                </div>
                <span class="tooltip-text-right">{{ autorizacion.Comentario }}</span>
              </div>
              <div
                v-if="index < autorizaciones.filter(a => a.Autorizadores?.IdAutorizadoresNivel === nivel.IdAutorizadoresNivel).length-1"
                class="d-inline-block text-dark mb-1 mx-2 fs-4"
              >
                →
              </div>
            </div>
            <div v-if="autorizaciones.filter(a => a.Autorizadores?.IdAutorizadoresNivel === nivel.IdAutorizadoresNivel)?.length == 0" class="d-flex align-items-center justify-content-center">
              <div class="tooltip-container">
                <div class="rounded-3 d-inline-flex flex-column align-items-center justify-content-center p-1 px-2 select-nada-2 sombra-sm">
                  <span>{{ $t('Pendiente') }}</span>
                  <span class="fs-8 fw-normal">XX xx</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Observaciones -->
      <div v-for="(observacion, indexObs) in form.Observacions.filter(observacion => !observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == user.idPersona))" :key="indexObs" class="p-3 border sombra-sm fondo-secundario rounded" :class="{ 'border-warning': observacion.Obligatorio, 'border-light-subtle': !observacion.Obligatorio  }">
        <!-- <div v-if="!observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == user.idPersona)"> -->
          <div class="mb-0 d-flex flex-row gap-2 justify-contents-center align-items-center">
            <h4 id="exampleTextarea" style="">{{ observacion.NombreObservacion }} <span v-if="observacion.Obligatorio" class="text-danger">*</span></h4>
          </div>
          
          <p class="w-100" style="white-space: pre-wrap;  word-wrap: break-word;">{{ observacion.Descripcion }}</p>

          <!-- Mostrar campos diferentes según el tipo de observación -->
          <div v-if="observacion.IdTipoObservacion === '6A89FB8F-18B7-45B7-8015-AB1445BBAD4A'.toLowerCase()"><!--Texto Corto-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === '9d19533b-3d29-4ff3-9be4-0ec902db6191'.toLowerCase()"><!--Fecha-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === '56cdebd4-89e8-4bb2-a26e-8f366c3f4159'.toLowerCase()"><!--Hora-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === '4BA48D01-AFEB-4D81-87D2-67FA07187CB5'.toLowerCase()" class="d-flex flex-column gap-1"><!--Opciones-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()" class="d-flex flex-column gap-2"><!--Rango-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase()" class="d-flex flex-column gap-2"><!--Número-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'e42de6bc-9113-4ba6-8818-49fa8a2c0c6f'.toLowerCase()">
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ $t(observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '') }}</p>
            </div>
          </div>
            
          <div v-if="observacion.IdTipoObservacion === 'bb1c6568-f8ea-42bc-9133-375f86fa2415'.toLowerCase()"><!--Archivo-->
            <div class="w-100 p-3 border-0 sombra-sm fondo-terciario rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
          </div>

          <div v-if="form.Observacions[indexObs].conComentario" class="position-relative" style="width: 100%;">
            <label for="descripcion">{{ $t('comentario') }}</label>
            <textarea id="descripcion" v-model="form.Observacions[indexObs].Valores[0].Comentario" class="form-control" style="height: 120px; resize: none;" maxlength="500" disabled></textarea>

            <div class="mt-2 text-end">
              <span>{{ form.Observacions[indexObs].Valores[0]?.Comentario.length || 0 }}/500 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
            </div>
          </div>
      </div>

      <div v-if="loadingForm" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
      </div>
    </div>
  </form>
</template>

<script>
  import { ref, computed, onMounted, toRaw } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const form = ref({
      Descripcion: '',
      TituloEleccionEvaluado: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdCreador: null,
      IdFormulario: null,
      NombreFormulario: '',
      ConAccesoRestringido : false,
      AccesoFormulario: [],
      Observacions: [], // Array de objetos para observaciones
    });

    
    const persona = ref([]);
    const autorizaciones = ref([]);
    const selectedPersona = ref(null); // Persona seleccionada
    const selectedAsignaturaId = ref(null); // Asignatura seleccionada
    const loadingPersonas = ref(false);
    const loadingCursosGrupos = ref(false);
    const loadingMaterias = ref(false);
    const loadingForm = ref(false);
    const loadingSubmit = ref(false);
    const comentario = ref('');
    
    let evaluados = ref([]);
    let searchQuery = ref('');
    let esAutorizable = ref(false);

    let ValorEvaluado = ref({});

    let grupos = ref([]);
    let estados = ref([]);
    let asignaturas = ref([]);

    const minRange = ref(1);
    const maxRange = ref(5);
    const stepValue = ref(0.5);

    const checkAuth = async  () => {
      if (user.value) {
        if(form.value.Habilitado == false){
          console.log('Formulario deshabilitado');
          alert('Formulario deshabilitado')
          localStorage.removeItem('redirectAfterLogin');
          await router.push('/formularios');
        }
        if(form.value.ConAutorizaciones){
          console.log(user?.value.idPersona)
          const idNivel = localStorage.getItem('idNivel');

          // Buscar el nivel actual
          const nivelActual = form.value.AutorizadoresNivel.find(n => n.IdAutorizadoresNivel === idNivel);
          let autorizadoAntes = true;

          if (nivelActual && nivelActual!=1 && !form.value.AutorizarDesordenado) {
            const ordenActual = nivelActual.NroOrden;

            for (let i = 1; i < ordenActual; i++) {
              const nivelPrevio = form.value.AutorizadoresNivel.find(n => n.NroOrden === i);
              if (!nivelPrevio) continue;

              const idsEstPrevio = (nivelPrevio.Estados ?? []).map(a => a.IdAutorizacionEstado);

              const ultimasAutorizaciones = autorizaciones.value.reduce((acc, curr) => {
                const id = curr.IdAutorizadores;
                const existente = acc[id];

                if (!existente || new Date(curr.FechaHora) > new Date(existente.FechaHora)) {
                  acc[id] = curr;
                }

                return acc;
              }, {});

              const estadosDeNivelPrevio = Object.values(ultimasAutorizaciones)
                .filter(a => idsEstPrevio.includes(a.IdAutorizacionEstado));

              const hayAprobada = Array.isArray(estadosDeNivelPrevio) &&
                estadosDeNivelPrevio.some(a => a.AutorizacionEstado?.Autorizado === true);

              if (!hayAprobada) {
                autorizadoAntes = false;
                break;
              }
            }
          }else{
            autorizadoAntes = true
          }
          console.log('asdasd')
          console.log(esAutorizable.value)
          console.log(form.value.AutorizadoresNivel.find(n => n.IdAutorizadoresNivel === idNivel).Autorizadores.some(autorizador => autorizador.IdPersona === user?.value.idPersona && autorizador.Inhabilitado != true))
          if((form.value.AutorizadoresNivel.find(n => n.IdAutorizadoresNivel === idNivel).Autorizadores.some(autorizador => autorizador.IdPersona === user?.value.idPersona && autorizador.Inhabilitado != true) && esAutorizable.value && autorizadoAntes) 
            ||(form.value.AutorizadoresNivel.find(n => n.IdAutorizadoresNivel === idNivel).Autorizadores.some(autorizador => autorizador.IdPersona === user?.value.idPersona && autorizador.Inhabilitado != true) && nivelActual.SePuedenAutoAutorizar)) {
            console.log("Tiene Permiso de Autorizar")
          }
          else{
            console.log('Usuario no tiene permiso a acceder.');
            alert('No tienes permiso para hacer esta Autorizacion por el momento')
            localStorage.removeItem('redirectAfterLogin');
            const idForm = localStorage.getItem('idForm');
            await router.push('/formularios/ver?idForm='+idForm);
          }
        }
        else{
          console.log("Usuario Autenticado"+form.value.ConAccesoRestringido)
        }
      }
    };

    const fetchGrupos = async () => {
      try {
        let response = await api.get(`api/Grupos/by-responsable/`+user.value?.idPersona);
        grupos.value = response.data
        esAutorizable.value = chequearPermisosAutorizaciones(form.value.Observacions[0].Valores[0].Submit.IdEvaluador)
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const chequearPermisosAutorizaciones = (IdPersonaSubmit) => {
      const idNivel = localStorage.getItem('idNivel');
      let autorizador = form.value.AutorizadoresNivel
          .find(nivel => nivel.IdAutorizadoresNivel === idNivel) // encontrar el nivel específico
          ?.Autorizadores
          .find(a => a.IdPersona == user?.value.idPersona);     // encontrar la persona dentro de ese nivel

      const nivelActual = form.value.AutorizadoresNivel.find(nivel => nivel.IdAutorizadoresNivel === idNivel)

      // Si se encuentra un autorizador
      if (autorizador) {
        // Si el tipo de permiso es "Todos", la autorización es siempre permitida
        if (nivelActual.TipoPermiso == "Todos") {
          return true;
        }
        else {
          for (const grupo of grupos.value) {
            if (nivelActual.TipoPermiso === grupo.Nombre && IdPersonaSubmit != null) {
              if (grupo.Listas[0].PersonasRelacionadas.some(s => s.IdPersona === IdPersonaSubmit)) {
                return true;
              }
            }
          }
        }
        console.log('Se encontro al autorizador')
      }
      
      // Si no se encuentra un autorizador o no cumple con las condiciones, denegar autorización
      return false;
    };
    
    const fetchForm = async () => {
      try {
        const idForm = localStorage.getItem('idForm');
        const response = await api.get(`api/Formularios/ByIdBasicoVer`, {
            params: {
                id: idForm
            },
        });
        let formTemp = response.data.Formulario;
        
        let autorizador = formTemp.AutorizadoresNivel
          .flatMap(nivel => nivel.Autorizadores) // juntar todos los autorizadores de todos los niveles
          .find(a => a.IdPersona == user?.value.idPersona);
        if(autorizador){
          console.log('Tiene permisos')
        }else{
          await router.push('/formularios');
        }
        //console.log(formTemp)


        const idSubmit = localStorage.getItem('idSubmit');
        var response2 = await api.get(`api/Valores/ByIdSubmit`, {
          params: {
            id: idSubmit,
          },
        });

        //console.log(response2.data)

        formTemp.Observacions.forEach((observacion) => {
          let Submit = structuredClone(response2.data)
          Submit.Valores = []
          // Aquí es donde se agregan los valores correspondientes de la respuesta
          const observacionValores = response2.data.Valores.filter(o => o.IdObservacion === observacion.IdObservacion);
          
          console.log(observacionValores)
          if (observacionValores.length>0) {
            // Asignar los valores encontrados a la observación
            observacionValores[0].Submit = Submit
            console.log(observacionValores)
            observacion.Valores = observacionValores; 
          }
          else{
            observacion.Valores.push({
              Submit: {
                IdEvaluador: null,
                IdEvaluado: null,
                IdAsignatura: null,
                IdCursoGrupo: null,
                FechaHora: null,
              },
              IdObservacion: observacion.IdObservacion, 
              ValorObservado: '',
              Comentario: '',
            });
          }
        });
        
        form.value = formTemp
        //console.log(form.value)
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };


    // Obtener los tipos de observación desde la API
    const fetchAutorizaciones = async () => {
      try {
        const idSubmit = localStorage.getItem('idSubmit');
        var response = await api.get(`api/Autorizaciones/ByIdSubmit`, {
          params: {
            id: idSubmit
          },
        });
        autorizaciones.value = response.data;
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchEstados = async () => {
      try {
        const idNivel = localStorage.getItem('idNivel');
        console.log(idNivel)

        var response = await api.get(`api/Autorizaciones/Estados`, {
          params: {
            id: idNivel
          },
        });
        estados.value = response.data;
        //console.log(estados.value)
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const submit = async (idEstado) => {
      try {
        // Asigna la versión limpia a form
        loadingSubmit.value = true;
        const idSubmit = localStorage.getItem('idSubmit');
        
        const idNivel = localStorage.getItem('idNivel');

        let autorizador = form.value.AutorizadoresNivel
          .find(nivel => nivel.IdAutorizadoresNivel === idNivel) // encontrar el nivel específico
          ?.Autorizadores
          .find(a => a.IdPersona == user?.value.idPersona);     // encontrar la persona dentro de ese nivel


        if(idSubmit != null && autorizador != null && idEstado != null){
          let autorizacion = {
            IdAutorizacion: "00000000-0000-0000-0000-000000000000",
            IdAutorizadores: autorizador ? autorizador.IdAutorizadores : null,
            IdAutorizacionEstado: idEstado,
            IdSubmit: idSubmit,
            Comentario: comentario.value,
            FechaHora: new Date().toISOString()
          }
          console.log(autorizacion)
          await api.post(`api/Autorizaciones`, toRaw(autorizacion));
          await router.push({ path: '/messagebox', query: { message: t('formEnviadoExitosamente'), redirect: t(`/formularios/ver?idForm=${form.value.IdFormulario}`) } });
          loadingSubmit.value = false;
        }else{
          loadingSubmit.value = false;
          alert('Error: Valores vacios')
        }
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loadingSubmit.value = false;
      }
    };

    const cancelForm = async() => {
      await router.push(localStorage.getItem('redirectAfterLogin'));
    };

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      loadingForm.value = true;
      await fetchForm();
      await fetchGrupos();
      await fetchAutorizaciones();
      await checkAuth();
      await fetchEstados();
      loadingForm.value = false;

      if(form.value.Observacions.some(obs => obs.TipoEvaluado == 'Personalizado')){
        const observacionPersonalizada = form.value.Observacions.find(obs => obs.TipoEvaluado == 'Personalizado');
        if (observacionPersonalizada) {
            persona.value = observacionPersonalizada.ItemsObservacions.map(item => item.IdPersonaNavigation);
        }
      }
    });

    return {
      form,
      submit,
      cancelForm,
      minRange,
      maxRange,
      stepValue,
      persona,
      selectedPersona,
      selectedAsignaturaId,
      asignaturas,
      loadingMaterias,
      loadingCursosGrupos,
      loadingPersonas,
      loadingForm,
      loadingSubmit,
      t,
      user,
      evaluados,
      searchQuery,
      ValorEvaluado,
      estados,
      comentario,
      esAutorizable,
      autorizaciones,
    };
  },
};
</script>

<style scoped>
  .form-check-input {
    appearance: none;
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid #DFBA6E; /* Borde personalizado */
    border-radius: 50%;
    outline: none;
    transition: 0.2s;
    flex-shrink: 0; /* Impide que el tamaño cambie */
  }


  /* Estilo cuando se selecciona */
  .form-check-input:checked {
    background-color: #DFBA6E; /* Color de fondo personalizado */
    border-color: #DFBA6E; /* Cambiar el color del borde */
  }
  /* Personalizar la pista (track) del slider */
  .form-range {
    width: 100%;
    height: 8px;
    background: #DFBA6E; /* Color de la pista */
    border-radius: 5px;
    outline: none;
    transition: background 0.3s;
  }

  /* Personalizar el pulgar (thumb) del slider */
  .form-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: #DFBA6E; /* Color del pulgar */
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
  }

  .form-range::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #DFBA6E; /* Color del pulgar */
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
  }

  /* Cambiar el color del pulgar cuando se arrastra */
  .form-range:active::-webkit-slider-thumb {
    background-color: #B18D43; /* Cambia el color al arrastrar */
  }

  .form-range:active::-moz-range-thumb {
    background-color: #B18D43; /* Cambia el color al arrastrar */
  }

  .list-group {
    max-height: 200px; /* Ajusta según lo necesario */
    overflow-y: auto; /* Añade desplazamiento si es necesario */
  }

  .list-group-item {
    background-color: white; /* Color de fondo de los items */
  }

  .list-group-item:hover {
    background-color: #f8f9fa; /* Color al pasar el mouse */
  }
</style>
